import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import MainLayoutFR from '../components/LayoutFR';
import MainLayoutEN from '../components/LayoutEN';
import HomeFR from '../components/HomeFR';
import Home from '../components/Home';
import AboutFR from '../components/AboutFR';
import About from '../components/About';
import ServicesFR from '../components/ServicesFR';
import Services from '../components/Services';
import ServiceFR from '../components/ServiceFR';
import Service from '../components/Service';
import TeamFR from '../components/TeamFR';
import Team from '../components/Team';
import PersonFR from '../components/PersonFR';
import Person from '../components/Person';
import ContactFR from '../components/ContactFR';
import Contact from '../components/Contact';
import Terms from '../components/Terms';
import Privacy from '../components/Privacy';
import Page404 from '../components/404';
import Test from '../components/Test';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
);

const AppRouter = () => (
  <Router>
    <Switch>
      {/* french version */}
      <AppRoute path="/" layout={MainLayoutFR} component={HomeFR} exact />
      <AppRoute path="/a-propos" layout={MainLayoutFR} component={AboutFR} />
      <AppRoute path="/services/:slug" layout={MainLayoutFR} component={ServiceFR} />
      <AppRoute path="/services" layout={MainLayoutFR} component={ServicesFR} />
      <AppRoute path="/equipe/:slug" layout={MainLayoutFR} component={PersonFR} />
      <AppRoute path="/equipe" layout={MainLayoutFR} component={TeamFR} />
      <AppRoute path="/contactez-nous" layout={MainLayoutFR} component={ContactFR} />
      <AppRoute path="/terms" layout={MainLayoutFR} component={Terms} />
      <AppRoute path="/privacy" layout={MainLayoutFR} component={Privacy} />
      {/* english version */}
      <AppRoute path="/home" layout={MainLayoutEN} component={Home} />
      <AppRoute path="/about-us" layout={MainLayoutEN} component={About} />
      <AppRoute path="/services-en/:slug" layout={MainLayoutEN} component={Service} />
      <AppRoute path="/services-en" layout={MainLayoutEN} component={Services} />
      <AppRoute path="/team/:slug" layout={MainLayoutEN} component={Person} />
      <AppRoute path="/team" layout={MainLayoutEN} component={Team} />
      <AppRoute path="/contact-us" layout={MainLayoutEN} component={Contact} />
      <AppRoute path="/terms" layout={MainLayoutEN} component={Terms} />
      <AppRoute path="/privacy" layout={MainLayoutEN} component={Privacy} />
      {/* test page */}
      <Route path="/test" component={Test} />
      {/* 404 - page not found */}
      <AppRoute layout={MainLayoutEN} component={Page404} />
    </Switch>
  </Router>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routes/Routes.js